<template>
  <div class="author_comment_wrap p_15">
    <div class="mb-3">
      <p class="">
        Add
        <span
          class="color_green cursor_pointer"
          v-if="!showCc"
          @click="showCc = true"
          >Cc | </span
        ><span
          class="color_green cursor_pointer"
          v-if="!showBcc"
          @click="showBcc = true"
          >Bcc</span
        >
      </p>
    </div>

    <div>
      <div v-if="showCc" class="mb-3">
        <label class="">Cc:</label>
        <div class="d_flex_start">
          <Multiselect
            v-model="selectedCcs"
            :options="users"
            :multiple="true"
            :showLabels="false"
            :close-on-select="true"
            placeholder="Select cc"
            label="email"
            track-by="email"
            :optionHeight="20"
          />
          <span class="d_flex_start pl_15 clear_color" @click="clearCcs"
            >Clear</span
          >
        </div>
      </div>
      <div v-if="showBcc">
        <label class="">Bcc:</label>
        <div class="d_flex_start">
          <Multiselect
            v-model="selectedBccs"
            :options="users"
            :multiple="true"
            :showLabels="false"
            :close-on-select="true"
            placeholder="Select bcc"
            label="email"
            track-by="email"
            :optionHeight="20"
          />
          <span class="d_flex_start pl_15 clear_color" @click="clearBccs"
            >Clear</span
          >
        </div>
      </div>
    </div>
    <div class="author_comment">
      <div :class="['', { has_error: errorFor('description') }]">
        <label for="description">Description</label>
        <div class="mb-3">
          <text-editor
            v-model:text="form.description"
            :id="'description'"
          ></text-editor>
          <v-errors :errors="errorFor('description')"></v-errors>
        </div>
      </div>
    </div>
    <div class="author_comment d-block">
      <div :class="['', { has_error: errorFor('attachments') }]">
        <label for="attachments">Attach file</label>
        <div class="mb-3">
          <div
            class="custom_tab_content_inner"
            :class="[{ has_error: errorFor('attachments') }]"
          >
            <div class="product_list_wrap">
              <div class="upload_btn dropzone-clickable mt_5 mb_10">
                <button type="button" class="btn btn-secondary width_150p">
                  Upload files
                </button>
              </div>
              <div class="product_list">
                <draggable
                  :list="form.attachments"
                  item-key="image"
                  tag="ul"
                  ghost-class="ghost"
                  class="d-inline-flex"
                  @end="imageSorted"
                >
                  <template #item="{ element, index }">
                    <li class="m-2">
                      <div class="inner">
                        <div class="img pe-2 pb-2">
                          <template
                            v-if="
                              ['gif', 'png', 'jpg', 'jpeg', 'JPG'].includes(
                                element.file_extension
                              )
                            "
                          >
                            <div
                              class="cross_ic cursor_pointer"
                              @click="removeImage(element, index)"
                            >
                              <i class="fas fa-times"></i>
                            </div>
                            <img
                              :src="element.file_path"
                              width="80px"
                              class="img-thumbnail"
                            />
                          </template>
                          <template
                            v-if="['pdf'].includes(element.file_extension)"
                          >
                            <div
                              class="cross_ic"
                              @click="removeImage(element, index)"
                            >
                              <i class="fas fa-times"></i>
                            </div>
                            <embed :src="element.file_path" />
                          </template>
                          <template
                            v-if="
                              [
                                'xls',
                                'xlsx',
                                'xlm',
                                'xla',
                                'xlc',
                                'xlt',
                                'xlw',
                                'csv',
                              ].includes(element.file_extension)
                            "
                          >
                            <div
                              class="cross_ic"
                              @click="removeImage(element, index)"
                            >
                              <i class="fas fa-times"></i>
                            </div>
                            <i class="fas fa-file-excel fa-10x"></i>
                          </template>
                          <template
                            v-if="['docx'].includes(element.file_extension)"
                          >
                            <div
                              class="cross_ic"
                              @click="removeImage(element, index)"
                            >
                              <i class="fas fa-times"></i>
                            </div>
                            <i class="fas fa-file-word fa-10x"></i>
                          </template>
                          <template
                            v-if="['zip'].includes(element.file_extension)"
                          >
                            <div
                              class="cross_ic"
                              @click="removeImage(element, index)"
                            >
                              <i class="fas fa-times"></i>
                            </div>
                            <i class="fas fa-file-archive fa-10x"></i>
                          </template>
                          <!-- <template v-if="allErrors && allErrors['attachments.'+index]">
                              pgh
                              <small v-for="(error, errorIndex) in allErrors['attachments.'+index]" :key="'error_' + index + '_attachments_'+errorIndex">{{error}}</small>
                          </template> -->
                        </div>
                        <div class="file_name mr-2">
                          <span>{{ element.original_file_name }}</span>
                        </div>
                      </div>
                    </li>
                  </template>
                </draggable>
              </div>
              <div class="dropzone-previews"></div>
              <div class="dropzone_wrap bg-light">
                <div
                  class="create_images_drag dropzone-clickable dropzone-container"
                >
                  <div class="images p-4 py-lg-5">
                    <span>Drag and drop images from your computer.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <v-errors :errors="errorFor('attachments')"></v-errors>
        </div>
      </div>
    </div>
    <div class="d_flex_end mt_20">
      <button
        type="button"
        class="btn btn-sm btn-primary ml_10 pl_15 pr_15"
        @click="submitReply"
      >
        Submit
      </button>
    </div>
  </div>
</template>

<script>
import TextEditor from '@/components/shared/TextEditor.vue';
import { mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';
import Dropzone from 'dropzone';
import Cookies from 'js-cookie';
import draggable from 'vuedraggable';

export default {
  name: 'InquiryDetailsReply',
  props: ['inquiryId', 'closeModal'],
  components: { TextEditor, Multiselect, draggable },
  data() {
    return {
      form: {
        description: '',
        email_type: 'reply',
        attachments: [],
        cc_emails: ['info@vlan24.com'],
      },
      showCc: false,
      showBcc: false,
      selectedCcs: null,
      selectedBccs: null,
      users: {},
      dropzoneInstance: null,
    };
  },
  computed: {
    ...mapGetters({
      user: 'auth/getUser',
    }),
  },
  mounted() {
    this.getUsers();

    // Prevent drag-and-drop opening file in browser
    window.addEventListener(
      'dragover',
      function (e) {
        e.preventDefault();
      },
      false
    );

    window.addEventListener(
      'drop',
      function (e) {
        e.preventDefault();
      },
      false
    );

    this.$nextTick(() => {
      this.initializeDropzone();
    });
  },
  updated() {
    if (!this.dropzoneInstance) {
      this.$nextTick(() => {
        this.initializeDropzone();
      });
    }
  },
  methods: {
    initializeDropzone() {
      if (this.dropzoneInstance) {
        this.dropzoneInstance.destroy();
        this.dropzoneInstance = null;
      }
      let that = this;

      // for image.
      that.$nextTick(() => {
        that.dropzoneInstance = new Dropzone('.dropzone-container', {
          clickable: '.dropzone-clickable',
          disablePreviews: true, // will not show preview
          createImageThumbnails: true,
          addRemoveLinks: true,
          previewsContainer: '.dropzone-previews',
          maxFiles: 2000,
          maxFilesize: 5,
          acceptedFiles:
            '.gif,.png,.jpg,.jpeg,.JPG,.xls,.xlsx,.xlm,.xla,.xlc,.xlt,.xlw,.csv,.pdf,.docx,.zip',
          accept: function (file, done) {
            const allowedTypes = [
              '.gif',
              '.png',
              '.jpg',
              '.jpeg',
              '.JPG',
              '.xls',
              '.xlsx',
              '.xlm',
              '.xla',
              '.xlc',
              '.xlt',
              '.xlw',
              '.csv',
              '.pdf',
              '.docx',
              '.zip',
            ];

            const ext = file.name
              .substring(file.name.lastIndexOf('.'))
              .toLowerCase();
            const maxSizeMB = 5;

            if (!allowedTypes.includes(ext)) {
              // that.showFailMsg('Unsupported file type.');
              done('Unsupported file type.');
            } else if (file.size > maxSizeMB * 1024 * 1024) {
              // that.showFailMsg("File too large." + maxSizeMB);
              done('File too large.');
            } else {
              done(); // file is accepted
            }
          },
          headers: {
            Authorization: `Bearer ${Cookies.get('auth_token')}`,
          },
          url: `${process.env.VUE_APP_API_BASE_URL}/temporary-image-upload`,
          success: function (file, response) {
            let image = {
              id: '',
              sort: that.form.attachments.length + 1,
              draft: response.draft,
              file_extension: response.file_extension,
              file_path: response.file_path,
              original_file_name: response.original_file_name,
              original_size: response.original_size,
            };
            that.form.attachments.push(image);
          },
          error: function (file, response) {
            that.showFailMsg(response);
            console.log(response, 'error error');
            let errors = that.errors ? that.errors : {};
            errors.attachments =
              errors && errors.attachments ? errors.attachments : [];
            errors.attachments = response?.errors?.file;
            that.errors = errors;
            // this.removeFile(file);
            if (file.accepted === false) {
              // alert("File type not supported: " + file.name);
              that.dropzoneInstance.removeFile(file); // optional: remove rejected file from queue
            }
          },
          removedfile: function () {
            let errors = that.errors ? that.errors : {};
            errors.attachments = null;
            that.errors = errors;
            // since no preview there is nothing to remove
            // file.previewElement.remove();
          },
        });
      });
    },
    removeImage(element, index) {
      if (!this.form) return;
      if (!this.form.attachments) return;
      if (!element.id) {
        let formData = new FormData();
        formData.append('draft', element.draft);
        this.axios.post('/temporary-image-remove', formData).then(() => {});
      }
      this.form.attachments.splice(index, 1);
      this.imageSorted();
    },
    imageSorted() {
      let sort = 1;
      for (let index = 0; index < this.form.attachments.length; index++) {
        this.form.attachments[index].sort = sort++;
      }
    },
    getUsers() {
      this.axios.get('/parent-customer-list').then(({ data }) => {
        this.users = data.data;
      });
    },
    clearCcs() {
      this.selectedCcs = [];
      this.form.cc_emails = [];
      this.showCc = false;
    },
    clearBccs() {
      this.selectedBccs = [];
      this.form.bcc_emails = [];
      this.showBcc = false;
    },
    submitReply() {
      this.allErrors = null;
      this.lyLoading = true;

      if (this.selectedCcs) {
        this.form.cc_emails = this.selectedCcs.map((email) => email.email);
      }
      if (this.selectedBccs) {
        this.form.bcc_emails = this.selectedBccs.map((email) => email.email);
      }

      let formData = new FormData();
      this.form.ticket_id = this.inquiryId;
      Object.keys(this.form).forEach((key) => {
        if (key !== 'attachments') {
          formData.append(key, this.form[key] ? this.form[key] : '');
        }
      });

      formData.append('attachments', JSON.stringify(this.form.attachments));
      formData.append('user', JSON.stringify(this.user));

      this.axios
        .post('/my-inquiry-ticket-reply', formData)
        .then(({ data }) => {
          if (data.success) {
            this.showSuccessMsg('Submitted Successfully!');
            this.closeModal();
          }
        })
        .catch((err) => {
          this.allErrors = err.response?.data?.errors;
          if (this.allErrors) {
            this.showFailMsg(err.response?.data?.message);
          }
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style scoped>
.cursor_pointer {
  cursor: pointer;
}
.d-block {
  display: block !important;
}
</style>
